import type { SearchProvider } from './types';

/**
 * Placeholder for future semantic candidate search integration.
 * Keep this registered shape so adding candidates later is additive.
 */
export const candidateSearchProvider: SearchProvider = {
  name: 'candidate-search-provider',
  canHandle: (context) => context.intent === 'candidates',
  aiSearch: async () => [],
  fuseSearch: async () => [],
};
